import { ComponentProps, useCallback } from 'react';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import { GenerateApiTokenModal } from 'TeamModule/components/GenerateApiTokenModal';

export const useGenerateTeamApiTokenModal = () => {
  const { openModal } = useDynamicModal();

  const openGenerateApiTokenModal = useCallback(
    (args: Omit<ComponentProps<typeof GenerateApiTokenModal>, 'onClose'>) => {
      openModal({
        modal: ({ isOpen: _isOpen, toggle }) => {
          return <GenerateApiTokenModal onClose={toggle} {...args} />;
        },
      });
    },
    [openModal],
  );

  return {
    openGenerateApiTokenModal,
  };
};
